export enum AccountRouteNames {
  PREFIX = 'sy/yonetim/account',
  PLAN = 'plan',
  PLAN_SELECT = 'plan/select',
  PAYMENT = 'payment',
  PAYMENT_SUCCESS = 'payment/success',
}
